export const RESOURCE_UNAVAILABLE_FOR_STUDENTS = {
  title: 'Recurso indisponível para estudantes',
  message:
    'Funcionalidade restrita a médicos-veterinários formados. Disponível após a graduação e registro profissional.'
};
